import { render, staticRenderFns } from "./DeclareOrderList.vue?vue&type=template&id=68ec9bec&"
import script from "./DeclareOrderList.vue?vue&type=script&lang=js&"
export * from "./DeclareOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports